class ExpandableText {
    defaultParams = {
        maxLineCount: 5,
        expandText: BX.message('EXPAND'),
        collapseText: BX.message('COLLAPSE'),
        expandButtonClass: 'expand-btn',
        expandButtonHiddenClass: 'expand-btn--hidden',
        collapsedTextElementClass: 'collapsed',
        isExpanded: false,
    }

    constructor(elementId, params = {}) {
        params = {...this.defaultParams, ...params};

        this.container = document.getElementById(elementId);

        if (!this.container) {
            return console.error(`Text element with id ${elementId} not found`);
        }

        this.textElement = this.createTextElement();

        this.container.replaceChildren(this.textElement);

        this.isExpanded = params.isExpanded;
        this.expandText = params.expandText;
        this.collapseText = params.collapseText;
        this.expandButtonClass = params.expandButtonClass;
        this.expandButtonHiddenClass = params.expandButtonHiddenClass;
        this.expandButton = this.createExpandButton();

        this.container.appendChild(this.expandButton);

        this.maxLineCount = params.maxLineCount;

        document.documentElement.style.setProperty("--collapsed-text-line-count", this.maxLineCount);

        this.collapsedTextElementClass = params.collapsedTextElementClass;
        this.resizeObserver = new ResizeObserver((entries) => {
            entries.forEach(() => this.handleResize());
        });

        this.resizeObserver.observe(this.textElement);
        this.handleResize();

        if (!this.isExpanded) {
            this.textElement.classList.add(this.collapsedTextElementClass);
        }
    }

    createTextElement() {
        const textElement = document.createElement('div');

        textElement.innerHTML = this.container.innerHTML;

        return textElement;
    }

    createExpandButton() {
        const expandButton = document.createElement('button');

        expandButton.className = `${this.expandButtonClass} ${this.expandButtonHiddenClass}`;
        expandButton.textContent = this.isExpanded
            ? this.collapseText
            : this.expandText;

        expandButton.addEventListener('click', () => this.isExpanded ? this.collapse() : this.expand());

        return expandButton;
    }

    handleResize() {
        if (this.isTextElementOverflown()) {
            this.showExpandButton();

            if (!this.isExpanded) {
                this.textElement.classList.add(this.collapsedTextElementClass);
            }
        } else {
            this.hideExpandButton();
            this.collapse();
        }
    }

    expand() {
        if (this.isExpanded) {
            return;
        }

        this.textElement.classList.remove(this.collapsedTextElementClass);
        this.expandButton.textContent = this.collapseText;
        this.isExpanded = true;
    }

    collapse() {
        if (!this.isExpanded) {
            return;
        }

        this.textElement.classList.add(this.collapsedTextElementClass);
        this.expandButton.textContent = this.expandText;
        this.isExpanded = false;
    }

    hideExpandButton() {
        this.expandButton.classList.add(this.expandButtonHiddenClass);
    }

    showExpandButton() {
        this.expandButton.classList.remove(this.expandButtonHiddenClass);
    }

    isTextElementOverflown() {
        const lineHeight = parseFloat(window.getComputedStyle(this.textElement).getPropertyValue('line-height'));
        return Math.round(this.textElement.scrollHeight / lineHeight) > this.maxLineCount;
    };
}
